import React, { useEffect, useState, useMemo } from "react";
import { UrlApi } from "../../../services/apirest";
import Navbar from "../../Navbar";
import {
  Container,
  Typography,
  Box,
  Button,
  Tooltip,
  IconButton,
  Grid,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TextField,
  DialogActions,
  MenuItem,
  ListItemIcon,
} from "@mui/material";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Modalobservaciones from "./Modalobservaciones";
import AssignmentIcon from "@mui/icons-material/Assignment";
import moment from "moment";
import Saldos from "../../referencias-tablas/clientes/datoscliente/Saldos";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PreviewIcon from "@mui/icons-material/Preview";
import ModalInfoCliente from "./ModalInfoCliente";


export default function Gestiones(props) {
  const [pedidos, setPedidos] = useState(); //trae todos los pedidos
  const [tabla, settabla] = useState(true);
  const [openModal, setopenModal] = useState(false);
  const globalTheme = useTheme();
  const [isLoading, setIsLoading] = useState(false); // Estado para controlar la carga
  const [datosformulario, setdatosformulario] = useState({});
  const [showModalSaldos, setshowModalSaldos] = useState(false);
  const [modalInfoCli, setModalInfoCli] = useState(false);

  // const obtenerPedidos = (estado) => {
  //     fetch(UrlApi + '/pedidos/xestado/' + estado)
  //         .then(data => data.json())
  //         .then(data => setPedidos(data))
  // };

  // const getPedidos = () => {
  //     switch (props.activeTab) {
  //         case 0:
  //             const estados2 =[19]
  //             obtenerPedidos(estados2);
  //             break;

  //         case 1:
  //             const estados =[21,22,23,24,25,32,40,41,243,244,248,263,301]
  //             const obtenerPedidos2 = (estado) => {
  //                 fetch(UrlApi + '/pedidos/xestado/' + estados)
  //                     .then(data => data.json())
  //                     .then(data => setPedidos(data))
  //             };
  //             console.log("url",UrlApi + '/pedidos/xestado/' + estados);

  //             obtenerPedidos2();
  //             break;

  //         // case 2:
  //         //     obtenerPedidos(22);
  //         //     break;

  //         default:
  //             console.error("Error")
  //             break;
  //     }
  // };

  // useEffect(() => {
  //     getPedidos();
  // }, [props.activeTab, tabla, openModal]);
  const obtenerPedidos = async (estado) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${UrlApi}/pedidos/xestado/${estado}`);
      const data = await response.json();
      setPedidos(data);
    } catch (error) {
      console.error("Error fetching pedidos:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getPedidos = () => {
    switch (props.activeTab) {
      case 0:
        obtenerPedidos(19);
        break;

      case 1:
        const estados = [
          21, 22, 23, 24, 25, 32, 40, 41, 243, 244, 248, 263, 301,
        ];
        obtenerPedidos(estados.join(",")); // Convertir el arreglo en una cadena separada por comas
        break;

      // case 2:
      //     obtenerPedidos(22);
      //     break;

      default:
        console.error("error");
        setIsLoading(false);
        break;
    }
  };

  useEffect(() => {
    getPedidos();
  }, [props.activeTab, tabla, openModal]);

  const handleClickOpen = async (datos) => {
    setopenModal(true);
    setdatosformulario(datos);
  };

  const handleOpenSaldos = async (datos) => {
    setshowModalSaldos(true);
    setdatosformulario(datos);
  };

  const handleOpenInfoCliente = async (datos) => {
    setModalInfoCli(true);
    setdatosformulario(datos);
    // console.log("datos", datos);
  };

  //TABLA PEDIDOS--------------------------------------------------------------------------
  const getColumns = () => {
    let columns = [
      { header: "#", accessorKey: "id", size: 45 },
      // { header: 'ID sisven', accessorKey: 'sisven_id', size: 100 },
      {
        header: "Cliente",
        accessorKey: "cliente",
        accessorFn: (row) =>
          `${row.sisven_id ? row.sisven_id + " - " : ""}${row.cliente}`,
      },

      { header: "Sucursal", accessorKey: "sucursal", size: 100 },
      {
        header: "Fecha",
        accessorFn: (p) => moment(p.registrado).format("DD-MM-YYYY HH:mm") ?? " ",
        size: 100,
      },
      // { header: 'Requerido', accessorFn: (p) => p.registrado ? moment(p.registrado).format("DD-MM-YYYY") : "No hay registro", size: 150 },
      { header: "Condicion pago", accessorKey: "condicion", size: 150 },
      { header: "Empresa", accessorKey: "empresa", size: 100 },
      { header: "Comercial", accessorKey: "comercial", size: 100 },
      { header: "Obs", accessorKey: "cantidad_observaciones", size: 50 },
      {
        header: "Pago anticipado",
        accessorKey: "mantiene_precio",
        accessorFn: (p) => (p.mantiene_precio === 1 ? "Pago anticipado" : "No"),
        size: 50,
      },
    ];

    return columns;
  };

  const getColumnsAprobados = () => {
    let columnsw = [
      { header: "#", accessorKey: "id", size: 45 },
      // { header: 'ID sisven', accessorKey: 'sisven_id', size: 100 },
      {
        header: "Cliente",
        accessorKey: "cliente",
        accessorFn: (row) =>
          `${row.sisven_id ? row.sisven_id + " - " : ""}${row.cliente}`,
      },
      { header: "Autoriza", accessorKey: "usuario_autoriza", size: 100 },
      { header: "Sucursal", accessorKey: "sucursal", size: 100 },
      {
        header: "Fecha",
        accessorFn: (p) => moment(p.registrado).format("DD-MM-YYYY HH:mm") ?? " ",
        size: 80,
      },
      // { header: 'Requerido', accessorFn: (p) => p.registrado ? moment(p.registrado).format("DD-MM-YYYY") : "No hay registro", size: 150 },
      { header: "Condicion pago", accessorKey: "condicion", size: 150 },
      { header: "Empresa", accessorKey: "empresa", size: 80 },
      { header: "Comercial", accessorKey: "comercial", size: 100 },
      { header: "Obs", accessorKey: "cantidad_observaciones", size: 50 },
      {
        header: "Pago anticipado",
        accessorKey: "mantiene_precio",
        accessorFn: (p) => (p.mantiene_precio === 1 ? "Pago anticipado" : "No"),
        size: 50,
      },
      {
        header: "Autorizado",
        accessorKey: "fecha_hora_autoriza",
        accessorFn: (p) =>
          p.fecha_hora_autoriza
            ? moment(p.fecha_hora_autoriza).format("DD-MM-YYYY HH:mm")
            : "",
        size: 100,
      },
    ];

    return columnsw;
  };

  const columnsAprobados = useMemo(
    () => getColumnsAprobados(pedidos),
    [pedidos]
  );

  const columns = useMemo(() => getColumns(), []);

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem", //larger tooltip font size
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    //   pagination: { pageIndex: 0, pageSize: 8 },
    columnPinning: { right: ["mrt-row-actions"] },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      // paddingTop: 1,
      // paddingBottom: 1,
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const rowBg = {
    19: "#F5CBA7", //Lo voy a poner en amarillo
    21: "#ABEBC6", //aprobado -> verde clarito
    22: "#EC7063", //rechazado -> rojo
    23: "#85C1E9", //asignado -> celestito
    24: "#138D75", //entregado
    25: "#D7BDE2", //Facturado -> violeta
    40: "#D6DBDF",
    41: "#EC7063", //CANCELADO -> BORDÓ
    243: "#f29696", //ERROR DE FACTURACION
    244: "#f8c471", //ERROR DE FACTURACION
  };

  // console.log("pedidos", pedidos);

  let filteredColumns = [];
  if (pedidos) {
    if (props.activeTab === 0) {
      filteredColumns = columns;
    } else if (props.activeTab === 1) {
      filteredColumns = columnsAprobados;
    }
  }
  // console.log("props.activeTab", props.activeTab);

  return (
    <div>
      <Box mb={5}>
        {pedidos && tabla ? (
          <ThemeProvider theme={tableTheme}>
            <MaterialReactTable
              enableColumnResizing
              columns={filteredColumns}
              data={pedidos}
              state={{ isLoading }} // Pasar el estado de carga a la tabla
              enableRowActions
              initialState={initialState}
              positionActionsColumn="last"
              localization={MRT_Localization_ES}
              muiTableHeadCellProps={tableHeadCellProps}
              muiTableBodyCellProps={({ row }) => ({
                align: "left",
                sx: {
                  backgroundColor:
                    row.original.id_condicionpago === 2
                      ? "#ebeda1" // amarillo para pago anticipado
                      : rowBg[row.original.id_estado] ?? "#fff",
                  color: "black",
                  borderColor: "black",
                },
              })}
              muiSearchTextFieldProps={muiSearchTextFieldProps}
              enableDensityToggle={false}
              layoutMode="grid"
              renderTopToolbarCustomActions={() => (
                <>
                  <Typography variant="poster" fontSize={26}>
                    <AssignmentIcon sx={{ size: 20 }}></AssignmentIcon>
                    Pedidos
                  </Typography>
                </>
              )}
              renderRowActionMenuItems={({ closeMenu, row, index }) => (
                <div>
                  <MenuItem
                    key={0}
                    onClick={() => {
                      handleClickOpen(row.original);
                      closeMenu();
                      console.log("row.original", row.original);
                      
                    }}
                    sx={{ m: 0 }}
                  >
                    <ListItemIcon>
                      <EditIcon color="primary" />
                    </ListItemIcon>
                    Agregar Observaciones
                  </MenuItem>
                  <MenuItem
                    key={1}
                    onClick={() => {
                      handleOpenSaldos(row.original);
                      closeMenu();
                    }}
                    sx={{ m: 0 }}
                  >
                    <ListItemIcon>
                      <ReceiptLongIcon color="secondary" />
                    </ListItemIcon>
                    Visualizar saldos
                  </MenuItem>
                  <MenuItem
                    key={1}
                    onClick={() => {
                      handleOpenInfoCliente(row.original);
                      closeMenu();
                    }}
                    sx={{ m: 0 }}
                  >
                    <ListItemIcon>
                      <PreviewIcon color="success" />
                    </ListItemIcon>
                    Visualizar info cliente
                  </MenuItem>
                </div>
              )}
              enableColumnActions={false}
              enableColumnFilters={false} //desactiva filtros x  columna
              enableHiding={false}
            // //

            // enableColumnDragging={false} //No permite que se arrastren las columnas.

            // positionExpandColumn='first'

            // enableEditing

            // muiTableBodyProps={{
            //     align: "center",
            // }}
            />
          </ThemeProvider>
        ) : (
          <Typography>Cargando datos...</Typography>
        )}
      </Box>
      {openModal ? (
        <Modalobservaciones
          open={setopenModal}
          datos={datosformulario}
          actualizar={getPedidos}
        ></Modalobservaciones>
      ) : null}
      {showModalSaldos ? (
        <Saldos
          open={showModalSaldos}
          setopen={setshowModalSaldos}
          dataCliente={datosformulario}
          tabla={settabla}
        />
      ) : null}

      {modalInfoCli ? (
        <ModalInfoCliente
          open={modalInfoCli}
          setopen={setModalInfoCli}
          dataCliente={datosformulario}
          tabla={settabla}
        />
      ) : null}
    </div>
  );
}
